import { Link } from "react-router-dom";

export const GrowthPlan = () => {
  return (
    <>
      <section id="pricing" className="cc-section cc-section-light">
        <div className="container">
          <div className="row">
            <div className="col-md-10 col-md-offset-1">
              <div className="cc-card text-center">
                <h2>Why this works</h2>
                <p>
                  Staff respond to immediate recognition. Instead of chasing people down or repeating tasks,
                  Crew Coin creates clear incentives that drive better behavior.
                </p>

                <h3 className="cc-trust-title">Built for managers</h3>
                <div className="row text-center cc-trust-grid">
                  <div className="col-sm-6">
                    <ul className="cc-list">
                      <li>{'\u2714'} Restaurant owners</li>
                      <li>{'\u2714'} General managers</li>
                      <li>{'\u2714'} Manufacturing</li>
                    </ul>
                  </div>
                  <div className="col-sm-6">
                    <ul className="cc-list">
                    <li>{'\u2714'} Supervisors</li>
                      <li>{'\u2714'} Shift leaders</li>
                      <li>{'\u2714'} Retail store managers</li>
                    </ul>
                  </div>
                </div>

                <h3 className="cc-trust-title">Results</h3>
                <div className="row text-center cc-trust-grid">
                  <div className="col-sm-6">
                    <ul className="cc-list">
                      <li>{'\u2714'} Reduce constant reminders</li>
                      <li>{'\u2714'} Improve accountability</li>
                    </ul>
                  </div>
                  <div className="col-sm-6">
                    <ul className="cc-list">
                      <li>{'\u2714'} Reward your best employees</li>
                      <li>{'\u2714'} Create a more motivated team</li>
                    </ul>
                  </div>
                </div>

                <hr className="cc-divider" />

                <p className="cc-price cc-price-tight">Run a smoother shift starting today</p>
                <p className="cc-subcopy">Set up your team in minutes and start rewarding the behavior you want to see.</p>
                <Link to="/signup" className="btn btn-custom2 cc-cta">Get started</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  );
};

